/**
 * ESSA PÁGINA VAI MORRER MESMO, ENTÃO, RELAXA QUANTO A REPETIÇÃO DE CÓDIGO BLZ
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import {
	createNewCheckout,
	refreshOfferTimeout,
	defineOfferTimeout,
	receiveSearchIntentionFromMetaSearch,
	getSearchIntention,
	setFlightFromMetaSearch,
	selectRoundTripFlights
} from "../actions";
import { isValid } from "../shared/utils";
import { calculateCheapestPrice } from "../shared/utils";
import { getFlightCheckoutDetails } from "../shared/requests-api";
import FlightSelected from "./FlightSelected";
import FlightBillingResume from "./FlightBillingResume";
import AirlineInfo from "./AirlineInfo";
import { invalidSearch } from "../shared/mocks/modal-invalid-search";
import tingle from "tingle.js";
import getURLParams from "../shared/getURLParams";
import PubSub from "pubsub-js";
import "../shared/pubsub-triggers";

const invalidSearchModal = new tingle.modal({
	closeMethods: ["button"],
	closeLabel: "OK",
	onClose: function() {
		window.location.href = "/";
	}
});

invalidSearchModal.isOpen = false;

class MetaSearchCheckout extends Component {
	constructor() {
		super();
		this.state = {
			selectedFlights: {
				inbound: [],
				outbound: []
			},
			tripType: ""
		};
	}

	hasFlightsFromDifferentCompanies() {
		if (!this.state.selectedFlights) return false;

		const { inbound: inboundFlight, outbound: outboundFlight } = this.state.selectedFlights;

		if (inboundFlight.length > 0 && outboundFlight.length > 0)
			return inboundFlight[0].airline !== outboundFlight[0].airline;

		return false;
	}

	/**
	 * este método se refere ao cenário em que o
	 * usuário achou um voo mais barato na mm e outro mais
	 * barato na airline.
	 */
	shouldEnableAlternativeSearch() {
		const outboundFlight = this.state.selectedFlights.outbound;
		const inboundFlight = this.state.selectedFlights.inbound;

		if (outboundFlight.length == 0 || inboundFlight.length == 0) {
			return false;
		}

		if (inboundFlight[0] && outboundFlight[0]) {
			const inboundCheaper = calculateCheapestPrice(
				inboundFlight[0].pricing.airline == null ? null : inboundFlight[0].pricing.airline.adult,
				inboundFlight[0].pricing.miles == null ? null : inboundFlight[0].pricing.miles.adult,
				!isValid(inboundFlight[0].pricing.ota) ? null : inboundFlight[0].pricing.ota.adult
			);

			const outboundCheaper = calculateCheapestPrice(
				outboundFlight[0].pricing.airline == null ? null : outboundFlight[0].pricing.airline.adult,
				outboundFlight[0].pricing.miles == null ? null : outboundFlight[0].pricing.miles.adult,
				!isValid(outboundFlight[0].pricing.ota) ? null : outboundFlight[0].pricing.ota.adult
			);

			const flightsCombined = inboundCheaper.concat(outboundCheaper);

			if (
				flightsCombined.match(/maxmilhas|exclusive|airline/g) !== null &&
				flightsCombined.match(/airline/g) !== null &&
				flightsCombined.match(/airline/g).length == 1
			) {
				return true;
			}

			return false;
		}
	}

	componentDidMount() {
		const flights = [];
		const href = window.location.href;
		const searchId = href.match(/comprar\/(.+)\?/);
		let outboundId = href.match(/outboundId=([a-zA-Z0-9_]+)/);
		let inboundId = href.match(/inboundId=([a-zA-Z0-9_]+)/);

		const isOta = getURLParams(href).metasearch !== undefined;

		if (searchId[1] == null || outboundId == null) {
			return null;
		}

		outboundId = outboundId[1];

		flights.push(outboundId);

		if (inboundId !== null) {
			inboundId = inboundId[1];

			flights.push(inboundId);
		}

		/** Procura na rota de checkout metasearch se o param s2 para ABs em api de checkout foi injetado
		 e guarda na sessão do user para usar na criação do checkout */
		setTimeout(() => {
			if (getURLParams(window.location.href).s2) {
				sessionStorage.setItem("s2", "true");
			}
		}, 1000);

		getFlightCheckoutDetails(flights, searchId[1], isOta)
			.then(response => {
				const data = response.data;

				if (data.flights.length !== flights.length) {
					invalidSearchModal.setContent(invalidSearch);
					invalidSearchModal.open();

					PubSub.publish("dataLayer", {
						event: "gaEvent",
						gaEventCategory: "Metasearch",
						gaEventAction: "Error",
						gaEventLabel:
							"Não conseguimos encontrar seus voos. Vamos te levar para a Home para refazer a sua busca."
					});
				} else {
					const flights = data.flights;
					const params = data.parameters;

					const searchIntentionObj = {
						id: data.id,
						legacyId: data.legacyId,
						createdDate: data.createdDate,
						fromCountry: params.fromCountry,
						toCountry: params.toCountry,
						cabin: params.cabin,
						tripType: params.tripType,
						isInternational: data.isInternational
					};

					this.props.getSearchIntention(params);

					this.props.receiveSearchIntentionFromMetaSearch(searchIntentionObj);

					this.setState({
						selectedFlights: {
							inbound: flights.filter(flight => flight.direction === "inbound"),
							outbound: flights.filter(flight => flight.direction === "outbound")
						}
					});

					flights.map(flight => {
						this.props.setFlightFromMetaSearch(flight);
					});

					this.props.defineOfferTimeout();
					this.props.refreshOfferTimeout();
				}
			})
			.catch(err => {
				invalidSearchModal.setContent(invalidSearch);
				invalidSearchModal.open();

				PubSub.publish("dataLayer", {
					event: "gaEvent",
					gaEventCategory: "Metasearch",
					gaEventAction: "Error",
					gaEventLabel:
						"Não conseguimos encontrar seus voos. Vamos te levar para a Home para refazer a sua busca."
				});
			});
	}

	componentDidUpdate(props, nextProps) {
		console.log("update com props ", props, nextProps);
	}

	outputFlightBillingResume() {
		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;

		console.log("flights/tripType: ", outboundFlight, inboundFlight, this.props.tripType);

		if (
			(inboundFlight.length > 0 && outboundFlight.length > 0 && this.props.tripType == "RT") ||
			(outboundFlight.length > 0 && this.props.tripType == "OW")
		) {
			return (
				<FlightBillingResume
					hasFlightsFromDifferentCompanies={this.hasFlightsFromDifferentCompanies()}
				/>
			);
		}

		return null;
	}

	render() {
		const { selectedFlights: { outbound: [firstOutbound], inbound: [firstInbound] } } = this.props;
		const isMiles = flight =>
			flight
				? flight.otaAvailableIn !== "airline" && flight.pricing.mmBestPriceAt === "miles"
				: false;

		const isOnlyInMiles = isMiles(firstOutbound) && (firstInbound ? isMiles(firstInbound) : true);

		return (
			<div className="checkoutpage" data-flight-onlymiles={isOnlyInMiles}>
				<section className="container-fluid">
					<div className="general-info">
						<h3 className="lead">Confirme seus voos</h3>
					</div>

					<div className="row">
						<div className="col-xs-16 col-md-12">
							<FlightSelected
								key={`checkout_outbound`}
								flightdata={
									this.state.selectedFlights.outbound.length > 0
										? this.state.selectedFlights.outbound[0]
										: null
								}
								enableAlternativeSearch={
									this.shouldEnableAlternativeSearch() && !this.hasFlightsFromDifferentCompanies()
								}
								enableSelectOtherFlight={false}
								flighType={"outbound"}
							/>

							<FlightSelected
								key={`checkout_inbound`}
								flightdata={
									this.state.selectedFlights.inbound.length > 0
										? this.state.selectedFlights.inbound[0]
										: null
								}
								enableAlternativeSearch={
									this.shouldEnableAlternativeSearch() && !this.hasFlightsFromDifferentCompanies()
								}
								enableSelectOtherFlight={false}
								flighType={"inbound"}
							/>
						</div>
						<div className="col-xs-16 col-md-4">
							<div className="checkout-wrapper">{this.outputFlightBillingResume()}</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	selectedFlights: state.selectedFlights,
	tripType: state.searchStatus.tripType !== null ? state.searchStatus.tripType : ""
});

const mapDispatchToProps = dispatch => {
	return {
		createCheckout: createCheckoutData => dispatch(createNewCheckout(createCheckoutData)),
		refreshOfferTimeout: () => dispatch(refreshOfferTimeout()),
		defineOfferTimeout: () => dispatch(defineOfferTimeout()),
		setFlightFromMetaSearch: flight => dispatch(setFlightFromMetaSearch(flight)),
		getSearchIntention: params => dispatch(getSearchIntention(params)),
		receiveSearchIntentionFromMetaSearch: flightSearchParams =>
			dispatch(receiveSearchIntentionFromMetaSearch(flightSearchParams)),
		selectRoundTripFlights: flights => dispatch(selectRoundTripFlights(flights))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MetaSearchCheckout);
